
export const SET_SHOWSESSIONGENERATEVIDEONOTICE = 'settingsPersist/SET_SHOWSESSIONGENERATEVIDEONOTICE';

export const setShowSessionsGenerateVideoNotice = (value) => {
  return (dispatch) => {
    dispatch({ type: SET_SHOWSESSIONGENERATEVIDEONOTICE, data: value })
  }
}
